export const GridEnabled = ({
  strokeColor = 'currentColor',
  width = 16,
  height = 16,
  ...props
}: {
  strokeColor?: string
  width?: number | string
  height?: number | string
}) => (
  <svg
    fill='none'
    height={height}
    viewBox='0 0 16 16'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5.09606 1.91113H3.18511C2.84723 1.91113 2.52319 2.04535 2.28427 2.28427C2.04535 2.52319 1.91113 2.84723 1.91113 3.18511V5.09606M13.3769 5.09606V3.18511C13.3769 2.84723 13.2427 2.52319 13.0037 2.28427C12.7648 2.04535 12.4408 1.91113 12.1029 1.91113H10.192M10.192 13.3769H12.1029C12.4408 13.3769 12.7648 13.2427 13.0037 13.0037C13.2427 12.7648 13.3769 12.4408 13.3769 12.1029V10.192M1.91113 10.192V12.1029C1.91113 12.4408 2.04535 12.7648 2.28427 13.0037C2.52319 13.2427 2.84723 13.3769 3.18511 13.3769H5.09606'
      stroke={strokeColor}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)
